$(function () {
    applyMasks();
    initValidation();
    initEvents();
});

function initEvents() {
    $('.saveRegistration').click(function () {
        if ($('#RegisterForm').valid()) {

            //We're using registrationSaveButton class here and below to avoid conflicts with global saveButton class causing save buttons not being disabled/enabled properly after validation errors
            $('.registrationSaveButton').addClass('disabled');

            var data = {
                registrationCount: $('#RegistrationCount').val(),
                adultRegistrationCount: $('#AdultRegistrationCount').val(),
                childrenRegistrationCount: $('#ChildrenRegistrationCount').val(),
                dietaryPreference: $("#DietaryPreference").val(),
                tShirtSize: $("#TShirtSize").val()
            };

            postAsJson('/api/Home/ActivityRegistration/' + activityId, JSON.stringify(data), function (data) {
                if (data.success) {
                    window.location = '/ActivityRegistrationConfirmation/' + activityId;
                }
                else {
                    $('.registrationSaveButton').removeClass('disabled');
                    addAlertMessage("alert-danger", "Sign Up Failed", data.errorMessage);

                    if (data.redirectUrl) {
                        window.location = data.redirectUrl;
                    }

                    if (data.allowWaitlist) {
                        $('#ParticipantWaitlistSignup').show();
                        $('#ActivityContactPannel').show();
                    }
                }
            });
        }
    });

    $('.removeRegistration').click(function () {
        $('.registrationSaveButton').addClass('disabled');

        postAsJson('/api/Home/RemoveActivityRegistration/' + activityId, '', function (data) {
            if (data.success) {
                window.location = '/Dashboard#myActivities';
            }
        });
    });

    $('.joinWaitlist').click(function () {
        $('.registrationSaveButton').addClass('disabled');

        var data = {
            registrationCount: $('#RegistrationCount').val(),
            adultRegistrationCount: $('#AdultRegistrationCount').val(),
            childrenRegistrationCount: $('#ChildrenRegistrationCount').val()
        };

        if ($('#RegisterForm').valid()) {
            postAsJson('/api/Home/ActivityWaitlist/' + activityId, JSON.stringify(data), function (data) {
                if (data.success) {
                    window.location = '/ActivityRegistrationConfirmation/' + activityId;
                }
                else {
                    $('.registrationSaveButton').removeClass('disabled');
                    addAlertMessage("alert-danger", "Sign Up Failed", data.errorMessage);

                    if (data.redirectUrl) {
                        window.location = data.redirectUrl;
                    }
                }
            });
        }
    });

    $('.joinParticipantWaitlist').click(function () {
        if ($('#WaitlistForm').valid()) {
            $('.registrationSaveButton').addClass('disabled');

            var data = {
                registrationCount: $('#WaitlistRegistrationCount').val(),
                adultRegistrationCount: $('#WaitlistAdultRegistrationCount').val(),
                childrenRegistrationCount: $('#WaitlistChildrenRegistrationCount').val()
            };

            if ($('#WaitlistForm').valid()) {
                postAsJson('/api/Home/ActivityWaitlist/' + activityId, JSON.stringify(data), function (data) {
                    if (data.success) {
                        window.location = '/ActivityRegistrationConfirmation/' + activityId;
                    }
                    else {
                        $('.registrationSaveButton').removeClass('disabled');
                        addWaitlistAlertMessage("alert-danger", "Sign Up Failed", data.errorMessage);

                        if (data.redirectUrl) {
                            window.location = data.redirectUrl;
                        }
                    }
                });
            }
        }
    });

    $('.removeWaitlist').click(function () {
        $('.registrationSaveButton').addClass('disabled');

        postAsJson('/api/Home/RemoveActivityWaitlist/' + activityId, '', function (data) {
            if (data.success) {
                window.location = '/Dashboard#myActivities';
            }
        });
    });

  $('.cancelRegistration').click(function () {
      if (cancelUrl) {
          window.location = cancelUrl;
      } else {
        window.location = '/Dashboard#myActivities';
      }
  });
}

function initValidation() {
    if ($('#RegisterForm').length > 0) {
        $('#RegisterForm').validate(extendValidationSettings({
        }));
    }

    if ($('#WaitlistForm').length > 0) {
        $('#WaitlistForm').validate(extendValidationSettings({
            success: null,
            errorContainer: '#waitlistErrorMessageBox',
            errorLabelContainer: '#waitlistErrorList',
        }));
    }
}

function addNumberInGroupValidation() {
    if ($('#RegistrationCount').length > 0) {
        $('#RegistrationCount').rules('add', {
            required: true,
            min: 1,
            max: 999,
            messages: {
                required: "Party Size is required.",
                min: "Party Size must be at least 1.",
                max: "Party Size must be less than 1000."
            }
        });
    }
}

function addWaitlistValidation() {
    if ($('#WaitlistRegistrationCount').length > 0) {
        $('#WaitlistRegistrationCount').rules('add', {
            required: true,
            min: 1,
            max: 999,
            messages: {
                required: "Party Size is required.",
                min: "Party Size must be at least 1.",
                max: "Party Size must be less than 1000."
            },
        });
    }
}

function addAdultAndChildRegistrationValidation() {
    if ($('#AdultRegistrationCount').length > 0) {
        $('#AdultRegistrationCount').rules('add', {
            required: true,
            min: function (element) {
                if ($('#ChildrenRegistrationCount').val() && parseInt($('#ChildrenRegistrationCount').val()) == 0) {
                    return 1;
                }

                return 0;
            },
            max: 999,
            messages: {
                required: "Number of Adults is required.",
                min: "Number of Adults or Number of Children must be at least 1.",
                max: "Number of Adults must be less than 1000."
            }
        });
    }

    if ($('#ChildrenRegistrationCount').length > 0) {
        $('#ChildrenRegistrationCount').rules('add', {
            required: true,
            min: function (element) {
                if ($('#AdultRegistrationCount').val() && parseInt($('#AdultRegistrationCount').val()) == 0) {
                    return 1;
                }

                return 0;
            },
            max: 999,
            messages: {
                required: "Number of Children is required.",
                min: "Number of Adults or Number of Children must be at least 1.",
                max: "Number of Children must be less than 1000."
            } 
        });
    }
}

function addAdultAndChildWaitlistRegistrationValidation() {
    if ($('#WaitlistAdultRegistrationCount').length > 0)  {
        $('#WaitlistAdultRegistrationCount').rules('add', {
            required: true,
            min: function (element) {
                if ($('#WaitlistChildrenRegistrationCount').val() && parseInt($('#WaitlistChildrenRegistrationCount').val()) == 0) {
                    return 1;
                }

                return 0;
            },
            max: 999,
            messages: {
                required: "Number of Adults is required.",
                min: "Number of Adults or Number of Children must be at least 1.",
                max: "Number of Adults must be less than 1000."
            }
        });
    }

    if ($('#WaitlistChildrenRegistrationCount').length > 0) {
        $('#WaitlistChildrenRegistrationCount').rules('add', {
            required: true,
            min: function (element) {
                if ($('#WaitlistAdultRegistrationCount').val() && parseInt($('#WaitlistAdultRegistrationCount').val()) == 0) {
                    return 1;
                }

                return 0;
            },
            max: 999,
            messages: {
                required: "Number of Children is required.",
                min: "Number of Adults or Number of Children must be at least 1.",
                max: "Number of Children must be less than 1000."
            }
        });
    }
}

function addTShirtSizeValidation() {
    if ($('#TShirtSize').length > 0) {
        $('#TShirtSize').rules('add', {
            required: true,
            messages: {
                required: "T-Shirt Size is required."
            }
        });
    }
}

function addDietaryPreferenceValidation() {
    if ($('#DietaryPreference').length > 0) {
        $('#DietaryPreference').rules('add', {
            required: true,
            messages: {
                required: "Dietary Preference is required."
            }
        });
    }
}

function addAlertMessage(alertClass, headerText, messageText) {
    var alert = $('<div class="alert ' + alertClass + '"><button type="button" class="close" data-dismiss="alert">×</button><h4>' + headerText + '</h4></div>');

    if (messageText) {
        alert.append('<span>' + messageText + '</span>');
    }

    alert.appendTo("#alertContainer");
}

function addWaitlistAlertMessage(alertClass, headerText, messageText) {
    var alert = $('<div class="alert ' + alertClass + '"><button type="button" class="close" data-dismiss="alert">×</button><h4>' + headerText + '</h4></div>');

    if (messageText) {
        alert.append('<span>' + messageText + '</span>');
    }

    alert.appendTo("#waitlistAlertContainer");
}
